import { WriteoffView } from './types';

export const createDefaultWriteoff = (): WriteoffView => {
  return {
    identifiers: {
      id: '',
      caseId: '',
      company: '',
      center: '',
      accountNumber: '',
      visitKey: '',
      writeoffNumber: '',
    },
    status: 'Draft',
    createdDate: new Date().toISOString(),
    createdBy: '',
    modifiedBy: '',
    patient: {
      accountNumber: '',
      firstName: '',
      lastName: '',
      middleName: '',
      payerName: '',
      payerCode: '',
    },
    detail: {
      writeoffAmount: 0,
      reason: '',
      justificationNotes: '',
    },
    notes: [],
    approvals: [],
  };
};
